import styled from '@emotion/styled';
import { Popover, PopoverTrigger, PopoverContent } from '@anyroad/popover';
import { Icon } from '@anyroad/icon';
import { roundPrice } from 'lib/pricing_utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { colors } from '@anyroad/theme';

interface DepositProps {
  amount: string;
  popupContent?: string;
}

const HelpIcon = styled(Icon)`
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
  width: 16px;
  height: 16px;
`;

const HelpIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
`;

const PopoverContentStyled = styled.div`
  background: white;
  border: 1px solid ${colors.border};
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 250px;
  font-size: 14px;
  color: ${colors.text.primary};
`;

export const Deposit = ({ amount, popupContent }: DepositProps) => {
  const { formatMessage } = useIntl();
  const content =
    popupContent ||
    formatMessage({
      defaultMessage: 'This booking requires a deposit to cover upfront costs',
    });

  return (
    <div
      className="CheckoutSummary-ContentBox DepositDue"
      data-testid="depositDue"
    >
      <table className="section">
        <tbody>
          <tr>
            <td>
              <span className="large">
                <span className="label">
                  <FormattedMessage defaultMessage="Deposit due now" />
                </span>
                <Popover placement="top">
                  <PopoverTrigger asChild>
                    <HelpIconButton
                      type="button"
                      aria-label="Deposit information"
                    >
                      <HelpIcon name="TooltipQuestionMark" />
                    </HelpIconButton>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverContentStyled>{content}</PopoverContentStyled>
                  </PopoverContent>
                </Popover>
              </span>
            </td>
            <td>
              <span className="large" data-testid="depositDueAmount">
                {roundPrice(amount)}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
